import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import styled from 'styled-components';
import { borderStyle } from '../merch-card/MerchCardSharedComponents';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
const TileWrapper = styled.div.withConfig({
  displayName: "ConditionalWrapper__TileWrapper",
  componentId: "sc-1g3u01a-0"
})(["display:contents;border:", ";", ""], borderStyle, breakpoint.tablet(_t || (_t = _`
  && > div {
    border-right: ${0} !important;
  `), borderStyle));
export const ConditionalWrapper = ({
  condition,
  wrapper,
  children
}) => condition ? wrapper(children) : children;
export const SuiteTileWrapper = children => /*#__PURE__*/_jsxs(TileWrapper, {
  children: [" ", children, " "]
});